module.exports = __webpack_public_path__ + "static/media/nutrit.084d1f47.png";